<template>
    <main class="page" role="main">
        <div class="c-communities__tiles u-m-t5">
            <div class="o-wrapper">
                <div class="o-grid o-grid--center">
                    <div class="o-grid__item u-width-10/12 u-width-full@l">
                        <h1 class="u-m-b4">Hot Communities</h1>
                        <div class="c-communities__wrapper u-p-b2 u-m-b5">
                            <div class="c-communities__tile" v-for="(item, index) in communities">
                                <a :href="'/' + item.url">
                                    <img class="c-communities__img u-m-r1@s" :src="$simpleStore.transformImageWithCloudfront(180, 180, 'img/communities/' + item.communityId + '/' + item.imgUrl, $root)" width="180" height="180">
                                    <div class="c-communities__name">{{item.name}}</div>
                                </a>
                            </div>
                        </div>
                        <div v-if="showSuggest" class="c-panel__community-noresults">
                            <div>
                                <p class="u-color-text u-bold" v-if="communities.length === 0">No community found</p>
                                <p class="u-color-text u-bold" v-else>No more communities found</p>
                                <p class="u-color-grey2 u-text-small">Can't find the community you are looking for? Why not suggest a community?</p>
                            </div>
                            <div>
                                <button class="c-panel__community-new" @click="$simpleStore.suggest($router, 'Search Community')"></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <a v-if="$root.user !== false" :href="'/post/create/'" class="c-article__add"></a>
        <a v-else class="c-article__add js-join-convo__cta"></a>
    </main>
</template>

<script>
export default {
    data() {
        return {
            communities: [],
            page: 1,
            loading: false,
            next: true,
            showSuggest: false,
            showLoader: false
        }
    },
    created() {
        this.fetchData();
    },
    mounted() {
        this.scrollCommunities();
    },
    methods: {
        fetchData() {
            let parameters = {params: {}};
            if (this.page > 1) {
                parameters.params.page = this.page;
            }
            this.loading = true;
            this.showLoader = true;
            this.$http.get('/api/v1/hot', parameters).then(response => {
                this.showLoader = false;
                if (response.data.results.length === 0 && this.page === 1) {
                    this.communities = [];
                    this.showSuggest = true;
                    this.loading = false;
                    return;
                }
                this.showSuggest = false;
                if (this.page === 1) {
                    this.communities = response.data.results;
                } else {
                    this.communities.push.apply(this.communities, response.data.results);
                }
                this.page++;
                this.next = response.data.results.length > 0;
                this.loading = false;
            }, response => {
                console.log('Errored:');
                console.log(response);
            });
        },
        scrollCommunities() {
            window.addEventListener('scroll', () => {
                //let bottomOfWindow = Math.max(window.scrollY, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight === document.documentElement.offsetHeight;
                // only calculate scroll height when not loading and when there are more posts to load
                if (this.loading === false && this.next) {
                    let percentageScroll = (Math.max(window.scrollY, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight) / document.documentElement.offsetHeight;
                    // load more posts when scrolled 90% of screen height
                    if (percentageScroll > 0.9) {
                        this.fetchData();
                    }
                }
            });
        }
    }
}
</script>
